import React from "react";
import moment from "moment";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import FormCreator from "../../common/FormCreator";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import history from "../../history";
import { postSwissportForm } from "../../redux/actions";

const InformationReleaseForm = ({ appData, postSwissportFormFunc }) => {
  const { firstName: initFirstName = "", lastName: initLastName = "" } =
    appData;

  const validateDDMMYYYY = (value) => {
    if (!value) return true;
    const date = moment(value, "DD/MM/YYYY", true);
    return date.isValid();
  };

  const initialState = {
    blurbSection1: {
      htmlObj: (
        <div>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            I understand and agree that my appointment is conditional upon the
            verification, to the Company`s satisfaction, of the information
            provided on the form, and that this information, and that contained
            on attached documents, is true and complete to the best of my
            knowledge. I also understand that I may incur civil and/or criminal
            liability if I attempt to obtain employment by deception and that
            any misrepresentation or omission of a material fact will be cause
            for immediate cancellation of condisderation for employment, or for
            dismissal if already employed.
          </p>
          <p style={{ textAlign: "justify", textJustify: "interWord" }}>
            I hereby authorise the Company, to verify information presented on
            this form and, to the extent permitted by law, to procure criminal
            background checks, investigative and credit reports for that purpose
            in the UK and, if appropriate, overseas. I also voluntarily
            authorise the Company, to perform reference checks of my employment,
            including my current employment, School, College and DSS/Benefits
            agencies to verify periods of unemployment where applicable.
          </p>
          <p
            className="pb-2"
            style={{ textAlign: "justify", textJustify: "interWord" }}
          >
            I hereby give permission to my previous employers to disclose
            detailed information to Swissport GB Ltd regarding my conduct
            (without their incurring any liability) whilst I was in their
            employment.
          </p>
        </div>
      ),
    },
    signatureIRF: {
      title: "Signature:",
      mandatory: true,
      value: `${initFirstName} ${initLastName}`,
    },
    dateIRF: {
      title: "Date:",
      value: `${moment().format("DD/MM/YYYY")}`,
      mandatory: true,
      validate: validateDDMMYYYY,
    },
    surnameIRF: {
      title: "Surname:",
      value: `${initLastName}`,
      mandatory: true,
    },
    firstnameIRF: {
      title: "First Name:",
      value: `${initFirstName}`,
      mandatory: true,
    },
    maidennameIRF: {
      title: "Maiden Name, or any previous name(s) used:",
      value: "",
    },
  };

  const [fields, setField] = useForm(initialState);
  const handleSubmit = () => {
    const fieldValuesPayload = formCreatorConvertToValues(fields);

    postSwissportFormFunc("informationReleaseForm", {
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/swissport-onboarding");
  };

  return (
    <FormCreator
      formTitle={"Information Release Form"}
      description={
        "Please read the following statements carefully and sign below."
      }
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/swissport-onboarding")}
      onboardingBranch={"swissport"}
    />
  );
};
InformationReleaseForm.propTypes = {
  appData: any,
  postSwissportFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postSwissportFormFunc: postSwissportForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(InformationReleaseForm);
